import script from "./MainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainPage.vue?vue&type=script&setup=true&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=2bc8e1b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc8e1b2"]])

export default __exports__